export default theme => ({
  messageBoxMaintenance: {
    background: 'transparent'
  },
  title: {
    marginLeft: theme.spacing(0.3),
    fontWeight: 700,
    fontStyle: 'bold'
  }
});
